document.addEventListener("DOMContentLoaded", function () {

  if (typeof jQuery !== 'undefined') {
    $('.product-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: $('.left-arrow'),
      nextArrow: $('.right-arrow'),
      dots: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  } else {
    console.error("jQuery not loaded - Slick will not work.");
  }
});
document.addEventListener("DOMContentLoaded", function () {
  if (typeof jQuery !== 'undefined') {
    $('.product-slider-col').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: $('.left-arrow-col'),
      nextArrow: $('.right-arrow-col'),
      dots: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  } else {
    console.error("jQuery not loaded - Slick will not work.");
  }
});

document.querySelectorAll('details.js-filter').forEach((el) => {
el.setAttribute('open', 'true');
el.querySelector('summary')?.addEventListener('click', function (e) {
    e.preventDefault();
});
});
  document.addEventListener("DOMContentLoaded", function () {
    const skuElement = document.querySelector('.product__sku');

    if (skuElement) {
      if (skuElement.classList.contains('visibility-hidden')) {
        skuElement.style.display = 'none';
      } else {
        skuElement.style.display = 'block';
      }
    }
  });

// popup for bonus
    document.addEventListener("DOMContentLoaded", function () {
      setTimeout(function () {
        var popup = document.getElementById("vaultbound-popup");
        if (popup) {
          popup.style.display = "block";
        }
      }, 10000); // 10 seconds delay

      document.getElementById("vaultbound-popup-close").addEventListener("click", function () {
        document.getElementById("vaultbound-popup").style.display = "none";
      });
    });


// document.addEventListener('DOMContentLoaded', function () {
//   const variantSelector = document.querySelector('select[name="id"]');
//   const displayedPrice = document.getElementById('displayed-price');
//   const selectedPriceValue = document.getElementById('selected-price-value');
//   const collectorMessage = document.getElementById('collector-message');
//   const rewardContainer = document.getElementById('reward-container');

//   // Simulate Shopify login/tag check
//   const isLoggedIn = window.customer && window.customer.id;
//   const isCollector = isLoggedIn && window.customer.tags.includes('collector_club_member');

//   function hideAllTiers() {
//     document.querySelectorAll('.reward-tier').forEach(tier => {
//       tier.style.display = 'none';
//     });
//   }

//   function updateTierDisplay(price) {
//     displayedPrice.textContent = `$${price}`;
//     selectedPriceValue.value = price;

//     hideAllTiers();

//     if (isCollector) {
//       if (price >= 400) {
//         document.getElementById('tier-400').style.display = 'block';
//       } else if (price >= 300) {
//         document.getElementById('tier-300').style.display = 'block';
//       } else if (price >= 200) {
//         document.getElementById('tier-200').style.display = 'block';
//       } else if (price >= 100) {
//         document.getElementById('tier-100').style.display = 'block';
//       } else {
//         document.getElementById('tier-none').style.display = 'block';
//       }
//     } else {
//       // Not eligible, show login/join prompt
//       collectorMessage.style.display = 'block';
//       rewardContainer.style.display = 'none';
//     }
//   }

//   function getSelectedVariantPrice() {
//     const selectedOption = variantSelector.options[variantSelector.selectedIndex];
//     const price = parseFloat(selectedOption.dataset.price);
//     if (!isNaN(price)) {
//       updateTierDisplay(price);
//     }
//   }

//   if (variantSelector) {
//     variantSelector.addEventListener('change', getSelectedVariantPrice);
//     getSelectedVariantPrice();
//   }
// });

// document.addEventListener('DOMContentLoaded', function () {
//   const variantSelector = document.querySelector('select[name="id"]');
//   const displayedPrice = document.getElementById('displayed-price');
//   const selectedPriceValue = document.getElementById('selected-price-value');
//   const collectorMessage = document.getElementById('collector-message');
//   const rewardContainer = document.getElementById('reward-container');

//   // Simulate Shopify login/tag check
//   const isLoggedIn = window.customer && window.customer.id;
//   const isCollector = isLoggedIn && window.customer.tags.includes('collector_club_member');

//   // Function to hide all reward tiers
//   function hideAllTiers() {
//     document.querySelectorAll('.reward-tier').forEach(tier => {
//       tier.style.display = 'none';
//     });
//   }

  // Update the displayed tier based on the selected product's price
  // function updateTierDisplay(price) {
  //   displayedPrice.textContent = `$${price}`;
  //   selectedPriceValue.value = price;

    // hideAllTiers();

  //   if (isCollector) {
      // if (price >= 400) {
      //   document.getElementById('tier-400').style.display = 'block';
      // } else if (price >= 300) {
      //   document.getElementById('tier-300').style.display = 'block';
      // } else if (price >= 200) {
      //   document.getElementById('tier-200').style.display = 'block';
      // } else if (price >= 100) {
      //   document.getElementById('tier-100').style.display = 'block';
      // } else {
      //   document.getElementById('tier-none').style.display = 'block';
      // }
  //   } else {
  //     // Not eligible, show login/join prompt
  //     collectorMessage.style.display = 'block';
  //     rewardContainer.style.display = 'none';
  //   }
  // }

  // Get the selected variant's price
  // function getSelectedVariantPrice() {
  //   const selectedOption = variantSelector.options[variantSelector.selectedIndex];
  //   const price = parseFloat(selectedOption.dataset.price);
  //   if (!isNaN(price)) {
  //     updateTierDisplay(price);
  //   }
  // }

  // Event listener for variant selector change
  // if (variantSelector) {
  //   variantSelector.addEventListener('change', getSelectedVariantPrice);
  //   getSelectedVariantPrice(); // Initialize with selected variant price
  // }

  // Function to update reward tiers based on the cart items
  // function updateCartRewardTiers(cart) {
  //   let maxPrice = 0;
  //   let hasSingleCardProduct = false;  // Flag to check if cart has single card product

  //   cart.items.forEach(function(item) {
  //     if (item.product.tags.includes('single-card')) {
  //       hasSingleCardProduct = true;
  //       if (item.price > maxPrice) {
  //         maxPrice = item.price;
  //       }
  //     }
  //   });

    // Show or hide bonus section based on the cart's contents
  //   if (hasSingleCardProduct) {
  //     rewardContainer.style.display = 'block';  // Show the reward section if there's a single-card product
  //     updateTierDisplay(maxPrice / 100); // Convert from cents to dollars
  //   } else {
  //     rewardContainer.style.display = 'none'; // Hide the reward section if no single-card product
  //   }
  // }

  // Function to fetch the cart and update reward tiers
  // function fetchCartAndUpdate() {
  //   fetch('/cart.js')
  //     .then(response => response.json())
  //     .then(cart => {
  //       updateCartRewardTiers(cart);
  //     });
  // }

  // Trigger the cart update when product is added/removed
  // document.addEventListener('cart:updated', function(event) {
  //   fetchCartAndUpdate(); // Update tiers whenever cart is updated
  // });

  // Initial cart update on page load
  // fetchCartAndUpdate();
// });

// variant logic

  (function () {
    const selectedVariants = [];
    const checkButton = document.getElementById("checkBtn");

    const checkboxes = document.querySelectorAll('.variant-checkbox');
    const variantImages = document.querySelectorAll('.variant-card');

    checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', function () {
        const variantId = this.getAttribute('data-variant-id');
        const card = document.querySelector(`.variant-card[data-variant-id="${variantId}"]`);

        if (this.checked) {
          if (!selectedVariants.includes(variantId)) {
            selectedVariants.push(variantId);
          }
          card.classList.add("selected");
        } else {
          const index = selectedVariants.indexOf(variantId);
          if (index > -1) {
            selectedVariants.splice(index, 1);
          }
          card.classList.remove("selected");
        }

        checkButton.style.display = selectedVariants.length > 0 ? "block" : "none";
        console.log('Selected variants:', selectedVariants);
      });
    });

    // Image click toggles checkbox
    variantImages.forEach(img => {
      img.addEventListener('click', function () {
        const variantId = this.getAttribute('data-variant-id');
        const checkbox = document.querySelector(`.variant-checkbox[data-variant-id="${variantId}"]`);

        if (!checkbox.disabled) {
          checkbox.checked = !checkbox.checked;
          checkbox.dispatchEvent(new Event('change'));
        }
      });
    });

    // Add to Cart
    checkButton.addEventListener("click", function () {
      if (selectedVariants.length === 0) return;

      const items = selectedVariants.map(variantId => ({
        id: parseInt(variantId),
        quantity: 1
      }));

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items })
      })
        .then(res => res.json())
        .then(data => {
          console.log('Added to cart:', data);
          window.location.href = '/cart';
        })
        .catch(error => {
          console.error('Cart error:', error);
          alert("There was an error adding to cart.");
        });
    });

    checkButton.style.display = "none";
  })();


    // See More logic
      document.addEventListener("DOMContentLoaded", function () {
      const seeMoreBtn = document.getElementById("seeMoreBtn");
      if (seeMoreBtn) {
        seeMoreBtn.addEventListener("click", function () {
          document.querySelectorAll('.hidden-card').forEach(card => {
            card.classList.remove("hidden-card");
          });
          seeMoreBtn.style.display = "none";
        });
      }
    });
  
  
 